export const booksData = [
    { "title": "Hellboy",
      "author": "Mike Mignola",
      "quantity":2
    },
    {
      "title": "The Satanic Bible",
      "author": "Anton LaVey",
      "quantity":1
    },
    {
      "title": "Breakfast of Champions",
      "author": "Kurt Vonnegut",
      "quantity":3
    },
    {
      "title": "Beren and Luthien",
      "author": "JRR Tolkien",
      "quantity":5
    },
    {
      "title": "Fire and Blood",
      "author": "George RR Martin",
      "quantity":10
    },
    { "title": "V For Vendetta",
      "author": "Alan Moore",
      "quantity":2
    },
    { "title": "Attack on Titan",
      "author": "Hajime Isayama",
      "quantity":2
    },
    { "title": "The Walking Dead",
      "author": "Robert Kirkman",
      "quantity":2
    },
    { "title": "Cirque De Freak",
      "author": "Derren Shan",
      "quantity":2
    }
]